module.exports = __webpack_public_path__ + "img/mac-mockup-02.c98dc605.png";